import React from 'react';
import {observer} from 'mobx-react';
import Celebration from './Celebration';
import {FormattedMessage} from 'react-intl';

const Birthday = observer(({birthday, Emoji}) => {
  return (
    <Celebration
      employee={birthday.employee}
      date={birthday.publishedAt}
    >
      <FormattedMessage
        id='hr_dashboard.feed.celebrations.BIRTHDAY_MESSAGE'
        values={{
          link: <a href={`/employees/${birthday.employee.id}`}>
                  {birthday.employee.name}
                </a>
        }}
      />
      {Emoji && <span className='ml1'>
        <Emoji emoji={'cake'} size={22}/>
      </span>}
    </Celebration>
  );
});

export default Birthday;
